export const hoursFrame = [
  { label: '1 Hours', value: '60' },
  { label: '2 Hours', value: '120' },
  { label: '3 Hours', value: '180' },
  { label: '4 Hours', value: '240' },
  { label: '5 Hours', value: '300' },
  { label: '6 Hours', value: '360' },
  { label: '7 Hours', value: '420' },
  { label: '8 Hours', value: '480' },
];
